// extracted by mini-css-extract-plugin
module.exports = {"main":"_3JSaUT1-n2v5fv6BHiHOiD","titulo":"_14uAn76pic42jwAypYky2q","button":"_22Von7AGRfcBNlxeqHlEZG"};